import { post } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import { translate } from '../../Services/translation';

export const ORGANIZATION_SEARCH_QUERY = "ORGANIZATION_SEARCH_QUERY";
export const ORGANIZATION_SEARCH_RECEIVE = "ORGANIZATION_SEARCH_RECEIVE";
export const ORGANIZATION_SEARCH_ERROR = "ORGANIZATION_SEARCH_ERROR";
export const ORGANIZATION_SEARCH_SHOW_FULL_FORM = 'ORGANIZATION_SEARCH_SHOW_FULL_FORM';
export const ORGANIZATION_SEARCH_SELECT_ITEM = "ORGANIZATION_SEARCH_SELECT_ITEM";
export const ORGANIZATION_SEARCH_TOGGLE_AUTOCOMPLETE = "ORGANIZATION_SEARCH_TOGGLE_AUTOCOMPLETE";
export const ORGANIZATION_SET_ORG_LIST = "ORGANIZATION_SET_ORG_LIST";

const rootRoute = '/api/selectorganization';
let selectedOrgId = '';

export const query = q => (dispatch, getState) => {

    dispatch({
        type: ORGANIZATION_SEARCH_QUERY,
        payload: {
            query: q,
        }
    });
    dispatch(filterList());
}

export const searchError = error => ({
    type: ORGANIZATION_SEARCH_ERROR,
    payload: {
        error,
    }
})

export const receive = result => ({
    type: ORGANIZATION_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result && result.length > 0
    }
})

export const setOrgList = organizationList => ({
    type: ORGANIZATION_SET_ORG_LIST,
    payload: {
        organizationList,
    }
})

export const fillOrganizationList = () => (dispatch, getState) => {  
    dispatch(setDefaultListValue());
    post(rootRoute + '/getall')
        .then(response => response.json())
        .then(organizations => dispatch(addClassToMainContent(organizations)))
        .then(organizations => dispatch(setOrgList(organizations)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
}

export const toggleShowFullForm = () => (dispatch, getState) => {
    const showFull = getState().selectOrganization.showFullForm;
    if (!showFull && !getState().selectOrganization.organizationList.length) {
            dispatch(fillOrganizationList());
    }
    
    dispatch(show(!showFull));
}

export const addClassToMainContent = (organizations) => (dispatch, getState) => {
    if (organizations.length > 0) {
        const mainContentEl = document.querySelector('.main-content');
        if (mainContentEl) {
            mainContentEl.classList.add('organization-select-visible');
        }
    }
    return organizations;
}

export const filterList = () => (dispatch, getState) => {

    const orgList = getState().selectOrganization.organizationList;
    const q = getState().selectOrganization.query.toLowerCase();
    if (q.length>2){
        const filteredList = orgList.filter(item => item.searchString.toLowerCase().indexOf(q) > -1);
        dispatch(receive(filteredList));
    }
}

export const hideAutocomplete = (hide) => (dispatch, getState) => {
    dispatch(autocompleteHidden(hide));
}

const autocompleteHidden = hideAutocomplete => ({
    type: ORGANIZATION_SEARCH_TOGGLE_AUTOCOMPLETE,
    payload: {
        showResult: !hideAutocomplete,
        query: '',
    }
})

const show = visible => ({
    type: ORGANIZATION_SEARCH_SHOW_FULL_FORM,
    payload: {
        showFullForm: visible,
    }
})

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
    const { result, selectedItem } = getState().selectOrganization;

    if (!result || !result.length) {
        return;
    }

    const max = result.length - 1,
        clip = index => index < 0 ? max : index > max ? 0 : index;

    let selectedItemIndex = selectedItem;
    let useArrows = result.length > 0;
    if (result.length === 1) {
        selectedItemIndex = 0;
        useArrows = false;
    }
    switch (event.keyCode) {
        case 38:
            if (useArrows) {
                dispatch(selectItem(clip(selectedItemIndex - 1)));
            }
            break;
        case 40:
            if (useArrows) {
                dispatch(selectItem(clip(selectedItemIndex + 1)));
            }
            break;
        case 13:
            // On enter: Set item in drop-down
            dispatch(setListValueByIndex(selectedItemIndex));
            break;
        default:
            break;
    }
}

export const setListValueByIndex = (indx) => (dispatch, getState) => {
    // First find the value in autocomplete and set select 
    const $elList = document.getElementById("selectOrganizationList");
    const $autoCompleteList = document.getElementsByClassName("select-org-autocomplete-result__item--name")[indx];

    if ($elList && $autoCompleteList) {
        const orgId = $autoCompleteList.getAttribute("data-org-id");
        $elList.value = orgId;

        if (selectedOrgId !== orgId) {
            dispatch(changeOrganization(false));
        }
    }

    // Hide autocomplete
    dispatch(hideAutocomplete(true));
}

export const setListValueByOrg = (org) => (dispatch, getState) => {
    const $elList = document.getElementById("selectOrganizationList");

    if ($elList) {
        $elList.value = org.id;
        dispatch(changeOrganization(false));
    }

    // Hide autocomplete
    dispatch(hideAutocomplete(true));
}

export const changeOrganization = (skipConfirm) => (dispatch, getState) => {
    const $elList = document.getElementById("selectOrganizationList");
    var onLoginPage = document.getElementById("selectOrgPage");
    if ($elList) {
        const orgId = $elList.value;

        if (onLoginPage) {
            skipConfirm = true;
        }

        if (selectedOrgId != orgId) {
            let changeOrg = false;
            if (!skipConfirm) {
                const regex = /\\n/g;
                var confirmText = '';
                if ($elList.nodeName.toUpperCase() === 'INPUT'){
                    confirmText = translate('common.organization.change.question.light');
                }
                else{
                    confirmText = translate('common.organization.change.question').replace("[orgName]", $elList[$elList.selectedIndex].text).replace(regex, "\n");
                }
                changeOrg = confirm(confirmText);
            }

            if (changeOrg === true || skipConfirm) {
                // Set selected ID to prevent jumping back to last set VALUE just before reload
                dispatch(setSelectedOrganization(orgId));

                return post(rootRoute + '/setcurrentorganization', $elList.value)
                    .then(response => {
                        if (onLoginPage) {
                            window.location.href = document.getElementById('header-logo').getAttribute('href');
                        } else {
                            window.location.reload()
                        }
                        
                    })
                    .catch(ex => dispatch(catchError(ex, error => searchError(error))));
            }
        }
    }

    // Hide autocomplete
    dispatch(hideAutocomplete(true));
}

export const setSelectedOrganization = selectedOrgId => ({
    type: ORGANIZATION_SEARCH_SELECT_ITEM,
    payload: {
        selectedOrg: { id: selectedOrgId, name: '', isSelected: true },
    }
})


export const setDefaultOrganization = defaultOrg => ({
    type: ORGANIZATION_SEARCH_SELECT_ITEM,
    payload: {
        defaultOrg,
    }
})


const selectItem = selectedItem => ({
    type: ORGANIZATION_SEARCH_SELECT_ITEM,
    payload: {
        selectedItem,
    }
})

const setDefaultListValue = () => (dispatch, getState) => {
    const $els = document.getElementsByClassName("selectOrganization");
    if ($els && $els.length > 0) {
        selectedOrgId = $els[0].getAttribute("data-org-id");
        dispatch(setSelectedOrganization(selectedOrgId));
    }
}
